export const ColorsMap = {
  anthracite: '#2B292E',
  armygreen: '#6C7241',
  beige: '#DAC4A3',
  black: '#000000',
  blue: '#3955D3',
  bordeaux: '#5F021F',
  brown: '#61350D',
  burgundy: '#800020',
  camel: '#BA9568',
  cherryRed: '#940E03',
  cobalt: '#0052DB',
  cream: '#F7F5C9',
  darkblue: '#222A51',
  darkbrown: '#4A2606',
  darkgreen: '#2D5302',
  darkgrey: '#4A4A4A',
  ecru: '#C8AB7C',
  framboise: '#B4364F',
  gold: '#F6B901',
  green: '#7ED321',
  grey: '#B8B8B8',
  jeansblue: '#8A9FB1',
  lightblue: '#BACEDD',
  lightgrey: '#E7E7E7',
  mustard: '#D7A726',
  navy: '#273646',
  navybrown: '#47211A',
  offwhite: '#EFEFE8',
  olive: '#525231',
  orange: '#FF8800',
  pink: '#FF5DC0',
  purple: '#60028B',
  red: '#D0021B',
  rose: '#F18099',
  salmon: '#F68866',
  sand: '#C9AF8D',
  silver: '#C4C4C4',
  turqoise: '#33D6D6',
  violet: '#7A0B7C',
  white: '#FFFFFF',
  wine: '#550B17',
  yellow: '#FFEB00',
  glitterblack: '#000000',
  multi: '#FF00F6',
  stripe: '#845858',
};

